module.exports = __webpack_public_path__ + "static/assets/c084f92ee6ad75562dd28d51cd054c78.png";